import '../../../../styles/VoucherButton.scss';

interface Props {
  onClick: () => void;
  appliedDiscount?: string | null;
  currency?: string;
}

const AddVoucherButton: React.FC<Props> = ({
  onClick,
  appliedDiscount,
  currency = '₱',
}) => {
  if (appliedDiscount) {
    const discountValue = parseFloat(appliedDiscount).toFixed(2);

    return (
      <div className="voucher-applied-row">
        <div className="voucher-label">
          <em>Voucher Applied - {currency}{discountValue} OFF!</em>
        </div>
        <div className="voucher-amount">
          - {currency} {discountValue}
        </div>
      </div>
    );
  }

  return (
    <button className="add-voucher-btn" onClick={onClick}>
      + Add voucher
    </button>
  );
};

export default AddVoucherButton;